import type { PropsWithChildren } from "react";

import { Box, type BoxProps } from "@similarweb/ui-components/foundations";

type Props = PropsWithChildren<
    {
        isVisible: boolean;
    } & Pick<BoxProps, "marginY">
>;

const MessageLoaderItem = ({ isVisible, marginY, children }: Props) => {
    if (!isVisible) {
        return null;
    }

    return (
        <Box
            alignSelf="flex-start"
            marginY={marginY}
        >
            {children}
        </Box>
    );
};

export default MessageLoaderItem;
